module.exports = __webpack_public_path__ + "static/img/avatarPlaceholder.dd736151.png";